import { render, staticRenderFns } from "./compareTable2.vue?vue&type=template&id=49170664&scoped=true&"
import script from "./compareTable2.vue?vue&type=script&lang=js&"
export * from "./compareTable2.vue?vue&type=script&lang=js&"
import style0 from "./compareTable2.vue?vue&type=style&index=0&id=49170664&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49170664",
  null
  
)

export default component.exports